import LoggedInUserGate from './LoggedInUserGate';

export default LoggedInUserGate;
